import React from 'react';
import SelectableProvider from 'core/context/selectable';
import Dialog from 'pages/Dashboard/pages/Fax/SendFaxForm';
import {
  PatientCompact,
} from 'pages/Dashboard/pages/Encounters/types/patient';
import {
  FaxContactDTO,
} from 'dtos';

export type FaxDialogParams = {
  patient?: PatientCompact;
  contact?: FaxContactDTO;
  patientMultimediaIds?: number[];
  attachFaceSheet?: boolean;
  shouldCreateFollowUpTodo?: boolean;
};

type FaxDialogProps = FaxDialogParams & {
  open: boolean;
  onClose: () => void;
};

export default function SendFaxDialog({
  open,
  onClose,
  patient,
  contact,
  patientMultimediaIds,
  attachFaceSheet,
  shouldCreateFollowUpTodo,
}: FaxDialogProps) {
  return (
    <SelectableProvider>
      <Dialog
        open={open}
        onClose={onClose}
        patient={patient}
        contact={contact}
        patientMultimediaIds={patientMultimediaIds}
        attachFaceSheet={attachFaceSheet}
        shouldCreateFollowUpTodo={shouldCreateFollowUpTodo}
      />
    </SelectableProvider>
  );
}
